<template>
  <div class="d-block pl-lg-5" v-if="Bom.StockCode" >
    <div  >
             
            <div  >
                <span class="p-1">
                    
                    {{Bom.StockCode}} ( {{qtyFormat( Bom.qty)}} )
                </span> 
                <span class="pl-1">{{Bom.Description}} </span> 
                <div   v-if="Bom.Bom && Bom.Bom.length>0" class="p-1" >
                    <NestedParts v-for="b in Bom.Bom" :key="b.StockCode" :Bom="b" :Level="nextLevel"></NestedParts>
                </div>  
            </div>
            

        </div>
  </div>
</template>

<script>
export default {
    name: "nestedParts",
    props: { Bom: Object,Level:Number},
    computed: {
        nextLevel(){
            return Number(this.Level)+1
        },
        colOrRow(){ 
            return this.Level<=2?"flex-column":"flex-row";
            //flex-row
            //flex-column
        },  
    levelGray() {
        let grayArray =["bg-gray-300","bg-gray-400","bg-gray-500","bg-gray-600","bg-gray-700","bg-gray-800","bg-gray-900","bg-gray-100","bg-gray-200"]
        let idx = this.Level
        if(this.Level>grayArray.length){
            idx = Number(this.Level/grayArray.length).toFixed(0);
        }
        return grayArray[idx];
    },
    hasSubItems(){
        return this.Bom.Bom && this.Bom.Bom.length>0
    }
  },
  methods:{ 
    qtyFormat(Num){
        return Number(Num).toFixed(3)
    }
  }
}
</script>

<style>

.CanClick{
    cursor: pointer;
}
.ml-2{
    margin-left: 15px;
}
.pl-lg-5{
    padding-left: 3rem !important;
}
.pr-2{
    padding-right: 5px;
    padding-bottom: 5px;
}
.pl-1{
    padding-left: 5px;
}
.bg-gray-100{
    background-color: var(--bs-gray-100);
}
.bg-gray-200{
    background-color: var(--bs-gray-200);
}
.bg-gray-300{
    background-color: var(--bs-gray-300);
}
.bg-gray-400{
    background-color: var(--bs-gray-400);
}
.bg-gray-500{
    background-color: var(--bs-gray-500);
    font-weight: bold;
}
.bg-gray-600{
    background-color: var(--bs-gray-400);
    font-weight: normal;
}
.bg-gray-700{
    background-color: var(--bs-gray-300);
    font-weight: normal;
}
.bg-gray-800{
    background-color: var(--bs-gray-200);
    font-weight: normal;
}
.bg-gray-900{
    background-color: var(--bs-gray-100);
    font-weight: normal;
} 
</style>